import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularClockPlusOutlineAlt: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_clock-plus-outline-alt"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="clock-plus-outline-alt icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 26.2147 47.6995 28.3623 47.136 30.4028C46.8508 31.4352 45.7827 32.041 44.7502 31.7559C43.7178 31.4707 43.112 30.4026 43.3971 29.3702C43.8687 27.6628 44.1212 25.8625 44.1212 24C44.1212 12.8874 35.1126 3.87879 24 3.87879C12.8874 3.87879 3.87879 12.8874 3.87879 24C3.87879 35.1126 12.8874 44.1212 24 44.1212C25.913 44.1212 27.7605 43.8548 29.5091 43.3582C30.5394 43.0656 31.6119 43.6637 31.9045 44.6941C32.1971 45.7244 31.599 46.7969 30.5687 47.0895C28.4788 47.683 26.2748 48 24 48C10.7452 48 0 37.2548 0 24Z"
        />
        <path d="M28.2512 11.7447C28.2512 11.0113 27.3748 10.417 26.6414 10.417C25.9079 10.417 25.1035 11.0113 25.1035 11.7447V24.9198L17.7187 29.2719C17.0836 29.6384 16.7716 30.8881 17.1381 31.5233C17.384 31.9492 17.9248 32.3244 18.3837 32.3244C18.6088 32.3244 18.8372 32.267 19.0465 32.1465L27.0951 27.4995C27.5056 27.2621 28.2512 26.8239 28.2512 26.3497V11.7447Z" />
        <path d="M43.3029 35.7445H39.3198V31.7613C39.3198 31.0279 38.7255 30.4336 37.9921 30.4336C37.2586 30.4336 36.6643 31.0279 36.6643 31.7613V35.7445H32.6812C31.9477 35.7445 31.3535 36.3388 31.3535 37.0722C31.3535 37.8056 31.9477 38.3999 32.6812 38.3999H36.6643V42.3831C36.6643 43.1165 37.2586 43.7108 37.9921 43.7108C38.7255 43.7108 39.3198 43.1165 39.3198 42.3831V38.3999H43.3029C44.0364 38.3999 44.6307 37.8056 44.6307 37.0722C44.6307 36.3388 44.0364 35.7445 43.3029 35.7445Z" />
      </svg>
    </span>
  );
};

export { RegularClockPlusOutlineAlt };
